var map = {
	"./Avatar-rule.svg": "d98a",
	"./add-member.svg": "2d50",
	"./apple.svg": "3376",
	"./call-avatar.svg": "bb2d",
	"./call-end.svg": "a254",
	"./call-hold-active.svg": "8fce",
	"./call-hold.svg": "f99d",
	"./call-keybord-active.svg": "b27e",
	"./call-keypad.svg": "b691",
	"./call-message.svg": "0f23",
	"./call-mute-active.svg": "1b55",
	"./call-mute.svg": "0bc2",
	"./call-pick.svg": "3189",
	"./check-success.svg": "1b76",
	"./check.svg": "4a24",
	"./close.svg": "bb7c",
	"./delete.svg": "571d",
	"./edit.svg": "2dd2",
	"./emoji.svg": "6118",
	"./facebook.svg": "7e4b",
	"./fi_delete.svg": "6889",
	"./fi_edit.svg": "dc4b",
	"./fi_play.svg": "bca0",
	"./fi_send.svg": "26b8",
	"./google.svg": "4460",
	"./new-greeting.svg": "4b62",
	"./pause.svg": "69b6",
	"./paypal.svg": "e66d",
	"./person_add_alt.svg": "65d2",
	"./photo.svg": "d740",
	"./play_arrow.svg": "bafa",
	"./ring-device.svg": "9c1a",
	"./stripe.svg": "0a98",
	"./upgrade-inactive.svg": "9cd0",
	"./upgrade.svg": "de49",
	"./verify-success.svg": "7d63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";